import * as React from 'react';
import { KeyboardArrowDownOutlined, KeyboardArrowUpOutlined } from '@mui/icons-material';

interface ToggleButtonProps {
    isOpen?: any;
    onClick?: any;
    isInvalid?: any;
    className?: string;
};

export const ToggleButton = (props: ToggleButtonProps) => (
    <button
        className={`toggle-button${props.className ? ` ${props.className}` : ''}`}
        onClick={props.onClick}
        onMouseDown={(e: any) => {
            // Prevent input from losing focus.
            e.preventDefault();
        }}>
        {props.isInvalid ? undefined : props.isOpen ? <KeyboardArrowUpOutlined /> : <KeyboardArrowDownOutlined />}
    </button>
);